import { BaseResource } from '../base-resource';
import { environment } from 'src/environments/environment';

export class BookingStatus extends BaseResource {
    constructor() {
        super();
        this.type = "bookingStatus";
        this.id = environment.BookingStatus;
    }
}